
<script lang="ts" setup>
import type { IFaq } from '~/server/api/faqs/types';

// Packages
// ---------------------------------------
// Composables
// ---------------------------------------
const { t } = useI18n();
const { data: allFaqs } = await useAsyncData(
  'faqs',
  () => $fetch<IFaq>('/api/faqs'),
  {
    default: () => ({
      docs: [],
      page: 1,
      limit: 10,
      totalDocs: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      pagingCounter: 1
    })
  }
);

// ---------------------------------------
// Meta
// ---------------------------------------

useHead(() => ({
  title: t('FAQS'),
}));
</script>

<template>
  <main class="inline-block h-full px-10">
    <header class="text-center mt-28 block mb-24">
      <span class="text-6xl font-bold">
        {{ $t('FAQS') }}
      </span>
      
      <div class="block my-6">
        <nuxt-link to="/" class="hover:underline">
          {{ $t('HOME') }}
        </nuxt-link>  
        -
        <span>
          {{ $t('ALL_FAQS') }}
        </span>
      </div>
    </header>

    <section class="py-8 mx-auto max-w-7xl gap-8 items-start">
      <FaqsItem
        v-for="faq in allFaqs.docs"
        :key="faq.id"
        :title="faq.question"
        :answer="faq.markdown"
      />
    </section>
  </main>
</template>
<style lang="scss" scoped>
main {
  background-color: #fff;
}
</style>